import { render, staticRenderFns } from "./CategoryMenuCard.vue?vue&type=template&id=3fed41e5&scoped=true"
import script from "./CategoryMenuCard.vue?vue&type=script&lang=js"
export * from "./CategoryMenuCard.vue?vue&type=script&lang=js"
import style0 from "./CategoryMenuCard.vue?vue&type=style&index=0&id=3fed41e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fed41e5",
  null
  
)

export default component.exports